export const PlateMindLogo = ({ size = 40, className = "" }) => {
  return (
    <img 
      src="/platemind-logo.png"
      alt="PlateMind"
      width={size} 
      height={size} 
      className={`rounded-full ${className}`}
      style={{ objectFit: 'cover' }}
    />
  );
};

// SVG fallback version
export const PlateMindLogoSVG = ({ size = 40, className = "" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Orange circle background */}
      <circle cx="50" cy="50" r="48" fill="#FF7A00"/>
      {/* Heartbeat/glucose line */}
      <path 
        d="M8 50 H22 L28 50 L33 32 L40 68 L48 22 L56 72 L62 45 L68 50" 
        stroke="#1a1a1a" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      {/* Heart shape at end */}
      <path 
        d="M72 50 C72 50 74 46 78 46 C82 46 84 50 84 50 C84 50 86 46 90 46 C94 46 96 50 96 50 C96 56 84 64 84 64 C84 64 72 56 72 50 Z" 
        stroke="#1a1a1a" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      {/* Line after heart */}
      <path 
        d="M84 58 L84 50 H92" 
        stroke="#1a1a1a" 
        strokeWidth="2.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export const PlateMindLogoWithText = ({ size = 40, className = "" }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <PlateMindLogo size={size} />
      <span className="font-heading font-bold text-xl text-secondary">platemind</span>
    </div>
  );
};

// Keep old exports for backwards compatibility during transition
export const MealMindLogo = PlateMindLogo;
export const MealMindLogoWithText = PlateMindLogoWithText;
